import React from 'react';
import PropTypes from 'prop-types';
import {utils, writeFile} from 'xlsx';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {isEmpty, extractWorkSheetData, formatDate, ExcelDateToDateString} from "../../globals/GlobalFunctions";


export interface Props {
    excelData: any;
}

//csv format
function UnitedConciergeFormatter ({excelData}: Props) {
    //console.log(excelData, "DING");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    try {
        //Check for data and that there is a sheet in the data named Census
        if (!isEmpty(excelData) && excelData.Sheets.United !== undefined) {

            //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
            let sheetDataArray = extractWorkSheetData(excelData.Sheets.United);

            let rawCellArray: any[] = sheetDataArray[0];

            let columnRange: number = sheetDataArray[1];

            let rowRange: number = sheetDataArray[2];

            const valuesIndexCollection = {
                memberSSNIndex: rawCellArray.indexOf('Member SSN') + 1,
                //subscriberSSNIndex: rawCellArray.indexOf('Subscriber SSN') + 1,
                relationshipTypeIndex: rawCellArray.indexOf('Relationship Type') + 1,
                fnIndex: rawCellArray.indexOf('Member First Name') + 1,
                mnIndex: rawCellArray.indexOf('Member Middle Name') + 1,
                lnIndex: rawCellArray.indexOf('Member Last Name') + 1,
                planIndex: rawCellArray.indexOf('Plan ID') + 1,
                divisionIndex: rawCellArray.indexOf('Division ID') + 1,
                dobIndex: rawCellArray.indexOf('Member Date of Birth') + 1,
                subscriberIndex: rawCellArray.indexOf('Subscriber ID') + 1,
                addIndex: rawCellArray.indexOf('Member Address') + 1,
                add2Index: rawCellArray.indexOf('Member Address 2') + 1,
                cityIndex: rawCellArray.indexOf('Member City') + 1,
                stateIndex: rawCellArray.indexOf('Member State') + 1,
                zipIndex: rawCellArray.indexOf('Member Zip Code') + 1,
                sexIndex: rawCellArray.indexOf('Member Gender') + 1,
                enrollDateIndex: rawCellArray.indexOf('Effective Date') + 1,
                disenrollDateIndex: rawCellArray.indexOf('Termination Date') + 1,
                groupIndex: rawCellArray.indexOf('Group ID') + 1,
                memberSegIndex: rawCellArray.indexOf('Member Sequence') + 1,
                //divNameIndex: rawCellArray.indexOf('Division Name') + 1,
                groupNameIndex: rawCellArray.indexOf('Group Name') + 1,
            }

            let arrayOfMemberArrays: any[] = [[
                "External ID", "First Name", "Middle Name", "Last Name", "DOB", "Gender", "Member Type", "Subscriber ID", "SSN", "Plan", "Company", "Division", "Effective Date",
                "Term Date", "Email", "Mobile Phone", "Home Phone", "Work Phone", "Address 1", "Address 2", "City", "State", "Zip", "Insurance Payer", "Insurance Group Number",
                "Insurance Member ID", "Dependent Code"
            ]];

            for (let i = 1; i < rowRange; i++) {
                //our member to later be pushed. Oh from what humble origins it begins
                let memberArray: any[] = [];
                //for each new member array we skip over the previous members determined by the column length, removing 1 to account for our zero based index at the beginning
                let rowMultiplier = columnRange * i - 1;

                let today = new Date();

                let termDate = new Date(Math.round((rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)] - 25568)*86400*1000));

                //remove terms
                if (termDate > today) {

                    if (valuesIndexCollection.subscriberIndex > 0 && valuesIndexCollection.memberSegIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString().toUpperCase()
                            + rawCellArray[(rowMultiplier + valuesIndexCollection.memberSegIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.fnIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.fnIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.mnIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.mnIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.lnIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.lnIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.dobIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.dobIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberArray.push(date.toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.sexIndex > 0) {
                        let sex = rawCellArray[(rowMultiplier + valuesIndexCollection.sexIndex)].toUpperCase();
                        if(sex === "MALE"){
                            sex = "M";
                        }
                        else if(sex === "FEMALE"){
                            sex = "F";
                        }
                        else if(sex === "UNKNOWN" || sex === "UNDEFINED"){
                            sex = "O";
                        }
                        memberArray.push(sex);
                    }
                    else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.relationshipTypeIndex > 0) {
                        switch (rawCellArray[(rowMultiplier + valuesIndexCollection.relationshipTypeIndex)]) {
                            case "Subscriber":
                                memberArray.push("Employee");
                                break;
                            case "Spouse":
                                memberArray.push("Spouse");
                                break;
                            case "Dependent":
                                memberArray.push("Child");
                                break;
                        }
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.subscriberIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.subscriberIndex)].toString().toUpperCase() + "01");
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.memberSSNIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.memberSSNIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.planIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.planIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.groupNameIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.groupNameIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.divisionIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.divisionIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.enrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.enrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberArray.push(date.toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.disenrollDateIndex > 0) {
                        let date = rawCellArray[(rowMultiplier + valuesIndexCollection.disenrollDateIndex)].toString();
                        if (date.includes("/")) {
                            date = formatDate(date);
                        } else if (date.length > 0 && date.length < 6) {
                            date = ExcelDateToDateString(date);
                        } else if (date === "117974") {
                            date = "";
                        }
                        if (date.length > 7) {
                            date = date.substring(4, 6) + "/" + date.substring(6, 8) + "/" + date.substring(0, 4);
                        }
                        memberArray.push(date.toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    memberArray.push("", "", "", "");

                    if (valuesIndexCollection.addIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.addIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.add2Index > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.add2Index)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.cityIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.cityIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.stateIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.stateIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    if (valuesIndexCollection.zipIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.zipIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    memberArray.push("");

                    if (valuesIndexCollection.groupIndex > 0) {
                        memberArray.push(rawCellArray[(rowMultiplier + valuesIndexCollection.groupIndex)].toString().toUpperCase());
                    } else {
                        memberArray.push("");
                    }

                    arrayOfMemberArrays.push(memberArray);
                }

            }

            //create our workbook
            const eligWorkbook = utils.book_new();
            //make the member sheet from our member array of arrays
            let ws1 = utils.aoa_to_sheet(arrayOfMemberArrays, {dateNF: 'mm.dd.yyyy'});

            //add it to the new workbook
            utils.book_append_sheet(eligWorkbook, ws1, "CAS UC Eligibility");
            //it exists and has a sheet send it back to app for export
            if (eligWorkbook && eligWorkbook.SheetNames.includes("CAS UC Eligibility")) {
                if(!eligWorkbook.Props) eligWorkbook.Props = {};

                const today = new Date();

                const month = today.getMonth() + 1;

                let monthString = "";

                let dayString = "";

                if(month < 10){
                    monthString = "0" + month.toString();
                }
                else{
                    monthString = month.toString();
                }

                const day = today.getDate();

                if(day < 10) {
                    dayString = "0" + day.toString();
                }
                else {
                    dayString = day.toString();
                }

                const year = today.getFullYear();

                //setting the workbook title through props
                eligWorkbook.Props.Title = "CAS UC Eligibility " + year + monthString  + dayString + ".csv";

                //writing the file which will make the download, second param is the name of the file and third is required options
                writeFile(eligWorkbook, "CAS UC Eligibility" + year + monthString  + dayString + ".csv",{});

                console.log("File Export Complete!");
                setSuccessAlert(true);
            }
            else {
                setErrorAlert(true);
                console.log("Unknown Export Error!");
            }

            //clear it out at the end in case of rerendering
            excelData.Sheets.United = undefined;
        }
    }
    catch(e) {
            console.log("ERROR", e);

            setErrorAlert(true);
            //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
            excelData.Sheets.United = undefined;
    }
    return (
            <div>
                {successAlert ? <Alert severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                    <AlertTitle>Success!</AlertTitle>
                    File Download Complete!
                </Alert> : <></> }
                {errorAlert ? <Alert severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                    <AlertTitle>Error!</AlertTitle>
                    There was an error with this file!
                </Alert> : <></> }
            </div>
    );
}

export default React.memo(UnitedConciergeFormatter)

UnitedConciergeFormatter.propTypes = {
    excelData: PropTypes.object.isRequired
};